import script from "./footerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./footerComp.vue?vue&type=script&setup=true&lang=js"

import "./footerComp.vue?vue&type=style&index=0&id=c610e97e&lang=scss"

const __exports__ = script;

export default __exports__